import { render, staticRenderFns } from "./alt-logo.vue?vue&type=template&id=0096255a&"
import script from "./alt-logo.vue?vue&type=script&lang=ts&"
export * from "./alt-logo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports